import script from "./AlbumPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlbumPicker.vue?vue&type=script&setup=true&lang=ts"

import "./AlbumPicker.vue?vue&type=style&index=0&id=be8ac8c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be8ac8c8"]])

export default __exports__